import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useBlockInspect } from "../../hooks/useBlockInspect";
import "./thankYou.css";

function ThankYou() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [imageOk, setImageOk] = useState(true);
  useBlockInspect();

  useEffect(() => {
    if (!user) navigate("/");
  }, [user, navigate]);

  return (
    <div className="thankyou-page">
      {imageOk ? (
        <img
          src="/php/img/ty.gif"
          className="thankyou-logo"
          alt=""
          onError={() => setImageOk(false)}
        />
      ) : null}
    </div>
  );
}

export default ThankYou;
